<template>
    <div class="animated fadeIn master-form-page">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <!-- Page Header -->
            <div class="d-flex align-items-center justify-content-between mb-4">
                <div>
                    <h4 class="page-header-title">Input Pengajuan Gadai</h4>
                    <span class="page-header-subtitle">Satu form untuk semua tipe pinjaman. Atribut barang mengikuti master Atribut Jenis Barang.</span>
                </div>
                <div class="step-badge">
                    <span class="step-dot"></span> Langkah 1 dari 2
                </div>
            </div>

            <b-form @submit.prevent="calculateMaksimumPinjaman">
                <!-- 1. DATA ANGGOTA -->
                <div class="section-card">
                    <div class="section-card-header">
                        <span class="section-card-title">DATA ANGGOTA</span>
                        <div class="section-card-actions">
                            <b-button @click="openSearchAnggotaModal" name="modalSearchAnggotaBtn" class="btn-pill-primary">
                                Pilih Anggota
                            </b-button>
                            <b-button @click="addAnggota" name="modalAddAnggotaBtn" class="btn-pill-outline">
                                Anggota Baru
                            </b-button>
                        </div>
                    </div>
                    <div class="section-card-body">
                        <div class="member-info-panel mb-3">
                            <b-row>
                                <b-col md="6">
                                    <div class="member-item-row">
                                        <span class="member-item-label">No. Anggota</span>
                                        <span class="member-item-value font-weight-bold">{{ anggota.no || '-' }}</span>
                                    </div>
                                    <div class="member-item-row">
                                        <span class="member-item-label">No. Identitas</span>
                                        <span class="member-item-value">{{ anggota.noIdentitas || '-' }}</span>
                                    </div>
                                    <div class="member-item-row">
                                        <span class="member-item-label">No. HP</span>
                                        <span class="member-item-value">{{ anggota.noHp || '-' }}</span>
                                    </div>
                                    <div class="member-item-row">
                                        <span class="member-item-label">Alamat</span>
                                        <span class="member-item-value">{{ anggota.alamat || '-' }}</span>
                                    </div>
                                </b-col>
                                <b-col md="6">
                                    <div class="member-item-row">
                                        <span class="member-item-label">Jenis Identitas</span>
                                        <span class="member-item-value">{{ anggota.jenisIdentitas || '-' }}</span>
                                    </div>
                                    <div class="member-item-row">
                                        <span class="member-item-label">Nama</span>
                                        <span class="member-item-value">{{ anggota.nama || '-' }}</span>
                                    </div>
                                    <div class="member-item-row">
                                        <span class="member-item-label">No. Rumah</span>
                                        <span class="member-item-value">{{ anggota.noRumah || '-' }}</span>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                        <div class="d-flex" v-if="anggota.no && anggota.no != '-'">
                            <b-button class="btn-outline-neutral mr-2" @click="$bvModal.show('modal-edit-anggota')">
                                Edit Anggota
                            </b-button>
                            <b-button class="btn-outline-neutral" @click="$bvModal.show('modal-detail-anggota')">
                                Detail Anggota
                            </b-button>
                        </div>
                    </div>
                </div>

                <!-- 2. DATA BARANG (DINAMIS) -->
                <div class="section-card">
                    <div class="section-card-header">
                        <span class="section-card-title">DATA BARANG</span>
                    </div>
                    <div class="section-card-body">
                        <!-- Primary Selections -->
                        <b-row class="mb-3">
                            <b-col md="4" class="mb-3 mb-md-0">
                                <label class="field-label">Tipe Pinjaman <span class="text-danger">*</span></label>
                                <b-form-select 
                                    v-model="input.tipePinjamanId" 
                                    :options="optTipePinjaman" 
                                    value-field="id" 
                                    text-field="name" 
                                    class="form-control-custom"
                                    required
                                >
                                    <template v-slot:first>
                                        <b-form-select-option :value="null" disabled>-- Pilih Tipe Pinjaman --</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-col>
                            <b-col md="4" class="mb-3 mb-md-0">
                                <label class="field-label">Jenis Barang <span class="text-danger">*</span></label>
                                <b-form-select 
                                    v-model="input.jenisBarang" 
                                    :disabled="optJenisBarangFiltered.length === 0"
                                    class="form-control-custom"
                                    required
                                >
                                    <template v-slot:first>
                                        <b-form-select-option :value="null" disabled>-- Pilih Jenis Barang --</b-form-select-option>
                                        <b-form-select-option v-for="(item, idx) in optJenisBarangFiltered" :key="idx" :value="{ id: item.id, name: item.name }">
                                            {{ item.name }}
                                        </b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-col>
                            <b-col md="4">
                                <label class="field-label">Merk Barang <span class="text-danger">*</span></label>
                                <b-form-select 
                                    v-model="input.merkBarang" 
                                    :disabled="optMerkBarang.length === 0"
                                    class="form-control-custom"
                                    required
                                >
                                    <template v-slot:first>
                                        <b-form-select-option :value="null" disabled>-- Pilih Merk Barang --</b-form-select-option>
                                        <b-form-select-option v-for="(item, idx) in optMerkBarang" :key="idx" :value="{ id: item.id, name: item.name }">
                                            {{ item.name }}
                                        </b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-col>
                        </b-row>

                        <b-row class="mb-3">
                            <b-col md="4" class="mb-3 mb-md-0">
                                <label class="field-label">Tipe Barang</label>
                                <multiselect
                                    v-model="input.tipeBarang" 
                                    :disabled="optTipeBarang.length === 0"
                                    :options="optTipeBarang" 
                                    :internal-search="true"
                                    :allow-empty="true"
                                    deselect-label=""
                                    select-label=""
                                    label="name"
                                    track-by="id"
                                    placeholder="-- Pilih Tipe Barang --"
                                />
                            </b-col>
                            <b-col md="4" class="mb-3 mb-md-0" v-if="isKendaraan">
                                <label class="field-label">Tahun</label>
                                <b-form-select v-model="input.tahun" class="form-control-custom" :disabled="optTahun.length === 0">
                                    <template v-slot:first>
                                        <b-form-select-option :value="null" disabled>-- Pilih Tahun --</b-form-select-option>
                                        <b-form-select-option v-for="(item, idx) in optTahun" :key="idx" :value="{ id: item.id, name: item.name }">
                                            {{ item.name }}
                                        </b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-col>
                            <b-col md="4" class="mb-3 mb-md-0">
                                <label class="field-label">Kondisi / Grade Barang</label>
                                <b-form-select v-model="input.kondisi" :options="optKondisi" :disabled="optKondisi.length === 0" class="form-control-custom">
                                    <template v-slot:first>
                                        <b-form-select-option :value="null" disabled>-- Pilih Grade --</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-col>
                            <b-col md="4" v-if="!isKendaraan">
                                <label class="field-label">Warna</label>
                                <b-form-select v-model="input.warnaBarang" :options="optWarna" class="form-control-custom">
                                    <template v-slot:first>
                                        <b-form-select-option :value="null" disabled>-- Pilih Warna --</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-col>
                        </b-row>

                        <b-row class="mb-4" v-if="isKendaraan">
                            <b-col md="4">
                                <label class="field-label">Warna</label>
                                <b-form-select v-model="input.warnaBarang" :options="optWarna" class="form-control-custom">
                                    <template v-slot:first>
                                        <b-form-select-option :value="null" disabled>-- Pilih Warna --</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-col>
                        </b-row>

                        <!-- INNER SUB-CARD: ATRIBUT BARANG (DINAMIS DARI MASTER ATRIBUT) -->
                        <div class="dynamic-attributes-panel mb-4" v-if="input.jenisBarang && input.jenisBarang.id">
                            <div class="d-flex flex-wrap align-items-center justify-content-between mb-3 pb-2 border-bottom-subtle">
                                <h6 class="panel-subtitle mb-0 font-weight-bold">
                                    <i class="fa fa-sliders text-success mr-1"></i> Atribut Barang
                                </h6>
                                <span class="breadcrumb-subtle">
                                    {{ currentTipePinjamanName }} <i class="fa fa-angle-right mx-1"></i> {{ currentJenisBarangName }} <i class="fa fa-angle-right mx-1" v-if="currentMerkBarangName"></i> {{ currentMerkBarangName }}
                                </span>
                            </div>

                            <div v-if="isLoadingAttributes" class="text-center py-4">
                                <b-spinner small class="text-success mr-2"></b-spinner>
                                <span class="text-muted small">Memuat atribut barang...</span>
                            </div>

                            <div v-else-if="dynamicAttributes.length === 0" class="text-center py-3 text-muted small bg-light-subtle rounded">
                                Tidak ada atribut khusus untuk jenis barang ini.
                            </div>

                            <!-- Dynamic Attributes Grid -->
                            <b-row v-else>
                                <b-col 
                                    v-for="(attr, aIdx) in dynamicAttributes" 
                                    :key="aIdx" 
                                    md="6" 
                                    class="mb-3"
                                >
                                    <!-- Field Label with mandatory indicator -->
                                    <label class="field-label">
                                        {{ attr.label }}
                                        <span v-if="attr.mandatory || attr.isMandatory" class="text-danger">*</span>
                                    </label>

                                    <!-- 1. FREETEXT -->
                                    <div v-if="attr.dataType === 'Freetext'">
                                        <b-form-input 
                                            v-model="dynamicValues[attr.nameKey]"
                                            :maxlength="attr.lengthLimit || undefined"
                                            :required="attr.mandatory || attr.isMandatory"
                                            :placeholder="'Masukkan ' + attr.label"
                                            class="form-control-custom"
                                        ></b-form-input>
                                        <span v-if="attr.lengthLimit" class="field-help-text">
                                            maks. {{ attr.lengthLimit }} karakter
                                        </span>
                                    </div>

                                    <!-- 2. NUMERIC -->
                                    <div v-else-if="attr.dataType === 'Numeric'">
                                        <b-form-input 
                                            type="number"
                                            v-model="dynamicValues[attr.nameKey]"
                                            :required="attr.mandatory || attr.isMandatory"
                                            :placeholder="'Masukkan ' + attr.label"
                                            class="form-control-custom"
                                        ></b-form-input>
                                        <span v-if="attr.lengthLimit" class="field-help-text">
                                            maks. {{ attr.lengthLimit }} digit
                                        </span>
                                    </div>

                                    <!-- 3. SINGLE SELECT -->
                                    <div v-else-if="attr.dataType === 'Single Select'">
                                        <b-form-select 
                                            v-model="dynamicValues[attr.nameKey]"
                                            :required="attr.mandatory || attr.isMandatory"
                                            class="form-control-custom"
                                        >
                                            <template v-slot:first>
                                                <b-form-select-option :value="null" disabled>-- Pilih {{ attr.label }} --</b-form-select-option>
                                                <b-form-select-option 
                                                    v-for="(opt, oIdx) in parseOptions(attr.options)" 
                                                    :key="oIdx" 
                                                    :value="opt"
                                                >
                                                    {{ opt }}
                                                </b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </div>

                                    <!-- 4. MULTI SELECT -->
                                    <div v-else-if="attr.dataType === 'Multi Select'">
                                        <multiselect
                                            v-model="dynamicValues[attr.nameKey]"
                                            :options="parseOptions(attr.options)"
                                            :multiple="true"
                                            :close-on-select="false"
                                            :clear-on-select="false"
                                            :preserve-search="true"
                                            :placeholder="'-- Pilih ' + attr.label + ' --'"
                                            select-label=""
                                            deselect-label=""
                                            selected-label=""
                                        />
                                    </div>

                                    <!-- 5. DATE -->
                                    <div v-else-if="attr.dataType === 'Date'">
                                        <b-form-input 
                                            type="date"
                                            v-model="dynamicValues[attr.nameKey]"
                                            :required="attr.mandatory || attr.isMandatory"
                                            class="form-control-custom"
                                        ></b-form-input>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>

                        <!-- Kelengkapan Barang -->
                        <div class="mb-4">
                            <label class="field-label font-weight-bold">Kelengkapan Barang</label>
                            <div v-if="optKelengkapanBarang.length === 0" class="text-muted small">
                                Tidak ada kelengkapan khusus untuk jenis barang ini.
                            </div>
                            <b-form-checkbox-group 
                                v-else 
                                v-model="input.kelengkapanBarang" 
                                class="custom-checkbox-pill-group d-flex flex-wrap gap-2"
                            >
                                <b-form-checkbox 
                                    v-for="item in optKelengkapanBarang" 
                                    :key="item.id" 
                                    :value="{ id: item.id, name: item.name }"
                                    class="custom-check-pill"
                                >
                                    {{ item.name }}
                                </b-form-checkbox>
                            </b-form-checkbox-group>
                        </div>

                        <!-- Spesifikasi Barang (Jenis & Merk) -->
                        <b-row class="mt-4">
                            <b-col md="6" class="mb-3 mb-md-0">
                                <label class="field-label font-weight-bold">Spesifikasi Barang (Jenis)</label>
                                <div class="spek-block mb-3">
                                    <span class="spek-subhead">Penambahan</span>
                                    <div v-if="optSpekJenis.penambahan.length === 0" class="text-muted small mb-2">
                                        Tidak ada penambahan spesifikasi jenis.
                                    </div>
                                    <b-form-checkbox-group v-else v-model="input.spesifikasiBarangJenis" class="checkbox-list">
                                        <b-form-checkbox class="d-block mb-1" v-for="item in optSpekJenis.penambahan" :key="item.id" :value="item.id">
                                            {{ item.name }}
                                        </b-form-checkbox>
                                    </b-form-checkbox-group>
                                </div>
                                <div class="spek-block">
                                    <span class="spek-subhead">Pengurangan</span>
                                    <div v-if="optSpekJenis.pengurangan.length === 0" class="text-muted small mb-2">
                                        Tidak ada pengurangan spesifikasi jenis.
                                    </div>
                                    <b-form-checkbox-group v-else v-model="input.spesifikasiBarangJenis" class="checkbox-list">
                                        <b-form-checkbox class="d-block mb-1" v-for="item in optSpekJenis.pengurangan" :key="item.id" :value="item.id">
                                            {{ item.name }}
                                        </b-form-checkbox>
                                    </b-form-checkbox-group>
                                </div>
                            </b-col>

                            <b-col md="6">
                                <label class="field-label font-weight-bold">Spesifikasi Barang (Merk)</label>
                                <div class="spek-block mb-3">
                                    <span class="spek-subhead">Penambahan</span>
                                    <div v-if="optSpekMerk.penambahan.length === 0" class="text-muted small mb-2">
                                        Tidak ada penambahan spesifikasi merk.
                                    </div>
                                    <b-form-checkbox-group v-else v-model="input.spesifikasiBarangMerk" class="checkbox-list">
                                        <b-form-checkbox class="d-block mb-1" v-for="item in optSpekMerk.penambahan" :key="item.id" :value="item.id">
                                            {{ item.name }}
                                        </b-form-checkbox>
                                    </b-form-checkbox-group>
                                </div>
                                <div class="spek-block">
                                    <span class="spek-subhead">Pengurangan</span>
                                    <div v-if="optSpekMerk.pengurangan.length === 0" class="text-muted small mb-2">
                                        Tidak ada pengurangan spesifikasi merk.
                                    </div>
                                    <b-form-checkbox-group v-else v-model="input.spesifikasiBarangMerk" class="checkbox-list">
                                        <b-form-checkbox class="d-block mb-1" v-for="item in optSpekMerk.pengurangan" :key="item.id" :value="item.id">
                                            {{ item.name }}
                                        </b-form-checkbox>
                                    </b-form-checkbox-group>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </div>

                <!-- 3. FOTO BARANG -->
                <div class="section-card">
                    <div class="section-card-header">
                        <span class="section-card-title">FOTO BARANG</span>
                    </div>
                    <div class="section-card-body">
                        <b-button class="btn-pill-primary mb-3" @click="addFotoPendukung" name="fotoPendukungAddBtn">
                            <i class="fa fa-plus mr-1"></i> Foto Pendukung
                        </b-button>
                        <div class="text-danger small mb-3" v-show="fotoPendukungError">* Foto Pendukung Maksimal 6 Foto</div>

                        <div class="d-flex flex-wrap gap-3 photo-slots-container">
                            <FotoPendukung 
                                v-for="item in input.fotoPendukung" 
                                :key="item.index" 
                                :fotoPendukung="item" 
                                :length="input.fotoPendukung.length" 
                                :minLength="minLengthFotoPendukung"
                                @remove="removeFotoPendukung"
                                @showModalCam="openModalCam" 
                                @showModalPreview="openModalPreview"
                            />
                        </div>
                        <div class="small text-muted mt-2">
                            * Foto Pendukung maksimal 6 foto.
                        </div>
                    </div>
                </div>

                <!-- 4. PROMO -->
                <div class="section-card">
                    <div class="section-card-header section-card-header--promo">
                        <span class="section-card-title">PROMO</span>
                    </div>
                    <div class="section-card-body">
                        <b-button class="btn-outline-neutral" @click="checkPromo" :disabled="isGettingPromo">
                            {{ isGettingPromo ? "Mengambil..." : "Cek Promo yang Dapat Digunakan" }}
                            <i class="fa fa-search ml-2"></i>
                        </b-button>
                        <div class="detail-promo-data mt-3" v-if="!isGettingPromo && isPromoRetrieved">
                            <div v-if="optPromo.length === 0" class="text-danger small">
                                * Tidak ada promo yang bisa digunakan untuk pemilihan barang gadai ini.
                            </div>
                            <b-form-checkbox-group v-else v-model="input.promo" name="promoList" stacked>
                                <b-form-checkbox class="mb-1 font-weight-500" v-for="item in optPromo" :key="item.id" :value="item.id">
                                    {{ item.name }}
                                </b-form-checkbox>
                            </b-form-checkbox-group>
                        </div>
                    </div>
                </div>

                <!-- 5. FOOTER ACTIONS -->
                <div class="d-flex justify-content-end align-items-center gap-2 mb-4">
                    <b-button type="button" class="btn-outline-neutral mr-2" @click="$router.go(-1)">
                        Batal
                    </b-button>
                    <b-button type="submit" name="gadaiSubmitBtn" class="btn-pill-primary" style="padding: 10px 36px !important; font-size: 15px !important;" :disabled="isSubmitting">
                        <b-spinner v-if="isSubmitting" small class="mr-1"></b-spinner>
                        {{ isSubmitting ? "Menghitung..." : "Hitung" }}
                    </b-button>
                </div>
            </b-form>

            <!-- MODALS -->
            <b-modal id="modal-input-anggota" body-class="modal-nopadding" size="xl" title="Input Anggota" hide-footer no-close-on-esc no-close-on-backdrop>
                <InputAnggota :isModal="modalAnggota" @submitModalAnggota="inputNewAnggota" />
            </b-modal>
            <b-modal id="modal-edit-anggota" body-class="modal-nopadding" size="xl" title="Edit Anggota" hide-footer no-close-on-esc no-close-on-backdrop>
                <EditAnggota :isModal="modalAnggota" :idAnggota="anggota.id" @updateModalAnggota="editNewAnggota" />
            </b-modal>
            <b-modal id="modal-detail-anggota" body-class="modal-nopadding" size="xl" title="Detail Anggota" no-close-on-backdrop>
                <DetailAnggota :isModal="modalAnggota" :idAnggota="anggota.id" />
                <template v-slot:modal-footer="{ cancel }">
                    <b-button variant="secondary" name="cancelDetailAnggotaBtn" @click="cancel()">
                        Tutup
                    </b-button>
                </template>
            </b-modal>
            <ModalPilihAnggota @anggota-selected="selectAnggota" />
            <ModalRincian :namaLengkapBarang="namaLengkapBarang" :rincian="rincian" :isSubmitting="isSubmitting" @next="calculateConfirmation" />
            <ModalKonfirmasi 
                :isSubmitting="isSubmitting" :nilaiPinjaman="input.nilaiPinjaman"
                :anggota="anggota" :rincian="rincian" :namaLengkapBarang="namaLengkapBarang"
                @exec-submit="submitGadai"
            />
            <ModalSukses :rincian="rincian" @done="reset" />
            <ModalWebCam idWebcam="webcam-input-pengajuan" @photoTaken="setResult" />
            <ModalPreview modalId="modal-preview-gadai" :fotoPreview="activeFotoPreview" />
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import ModalPilihAnggota from '../ModalPilihAnggota'
import ModalRincian from '../ModalRincian'
import ModalKonfirmasi from '../ModalKonfirmasi'
import ModalSukses from '../ModalSukses'
import InputAnggota from '../../master/anggota/InputAnggota'
import EditAnggota from '../../master/anggota/EditAnggota'
import DetailAnggota from '../../master/anggota/DetailAnggota'
import FotoPendukung from '../../../components/webcam/FotoPendukung'
import ModalWebCam from '../../../components/webcam/ModalWebCam'
import ModalPreview from '../../../components/webcam/ModalPreview'

export default {
    name: 'pengajuan-gadai',
    components: {
        Multiselect,
        ModalPilihAnggota,
        ModalRincian,
        ModalKonfirmasi,
        ModalSukses,
        InputAnggota,
        EditAnggota,
        DetailAnggota,
        FotoPendukung,
        ModalWebCam,
        ModalPreview
    },
    data() {
        return {
            initStatus: 0,
            isGettingPromo: false,
            isPromoRetrieved: false,
            isSubmitting: false,
            isLoadingAttributes: false,
            modalAnggota: true,

            anggota: {
                id: null,
                nama: "-",
                no: "-",
                jenisBarang: "-",
                jenisIdentitas: "-",
                noIdentitas: "-",
                noHp: "-",
                noRumah: "-",
                alamat: "-",
                isComplete: false,
                shouldUpdate: false
            },

            rincian: {
                hargaBarang: 0,
                maksimumPinjaman: 0,
                minimumPinjaman: 0,
                perhitunganPromo: null,
                perhitunganKondisi: {},
                perhitunganSpek: [],
                perhitunganBonusGadaiPertama: {},
                perhitunganStatusAnggota: {},
                biayaAdmin: 0,
                noFaktur: "",
                showAlertNoFakturGanda: "false",
                alertNoImei: "",
                alertNoFakturGanda: "",
                alertGadai: "pengajuan"
            },

            namaLengkapBarang: "",

            // Main form inputs
            input: {
                tipePinjamanId: null,
                jenisBarang: null,
                merkBarang: null,
                tipeBarang: null,
                tahun: null,
                kondisi: null,
                warnaBarang: null,
                kelengkapanBarang: [],
                spesifikasiBarangJenis: [],
                spesifikasiBarangMerk: [],
                keterangan: "",
                promo: [],
                nilaiPinjaman: 0,
                fotoPendukung: [
                    { id: 0, index: 0, checkFotoBarangPendukung: false, fotoBarangPendukungPlaceholder: 'Choose a file', fotoBarangPendukung: null, fotoBarangPendukungBase64: null, activeFotoPendukungBase64: null }
                ]
            },

            // Dynamic Attribute Form Values (keyed by nameKey)
            dynamicValues: {},
            dynamicAttributes: [],

            // Options Master Lists
            optTipePinjaman: [],
            optAllJenisBarang: [],
            optMerkBarang: [],
            optTipeBarang: [],
            optTahun: [],
            optKondisi: [],
            optWarna: [
                { value: 'Hitam', text: 'Hitam' },
                { value: 'Putih', text: 'Putih' },
                { value: 'Silver', text: 'Silver' },
                { value: 'Abu-abu', text: 'Abu-abu' },
                { value: 'Emas / Gold', text: 'Emas / Gold' },
                { value: 'Biru', text: 'Biru' },
                { value: 'Merah', text: 'Merah' },
                { value: 'Hijau', text: 'Hijau' },
                { value: 'Lainnya', text: 'Lainnya' }
            ],
            optKelengkapanBarang: [],
            optSpekJenis: { penambahan: [], pengurangan: [] },
            optSpekMerk: { penambahan: [], pengurangan: [] },
            optPromo: [],

            // Webcam & Foto Pendukung
            fotoPendukungError: false,
            indexFotoPendukung: 1,
            minLengthFotoPendukung: 1,
            activeFotoPendukungIndex: null,
            activeFotoPreviewIndex: null,
            activeFotoPreview: null
        }
    },
    computed: {
        isKendaraan() {
            if (!this.input.tipePinjamanId) return false
            const found = this.optTipePinjaman.find(item => item.id === this.input.tipePinjamanId)
            if (found && found.name) {
                return found.name.toLowerCase().includes('kendaraan')
            }
            return this.input.tipePinjamanId === 2
        },
        optJenisBarangFiltered() {
            if (!this.input.tipePinjamanId) return []
            return this.optAllJenisBarang.filter(item => item.tipePinjamanId === this.input.tipePinjamanId)
        },
        currentTipePinjamanName() {
            const found = this.optTipePinjaman.find(item => item.id === this.input.tipePinjamanId)
            return found ? found.name : 'Tipe Pinjaman'
        },
        currentJenisBarangName() {
            return this.input.jenisBarang && this.input.jenisBarang.name ? this.input.jenisBarang.name : 'Jenis Barang'
        },
        currentMerkBarangName() {
            return this.input.merkBarang && this.input.merkBarang.name ? this.input.merkBarang.name : ''
        }
    },
    methods: {
        init() {
            this.initStatus = 0

            // Initialize default foto pendukung slots (default 1 foto)
            this.input.fotoPendukung = [
                { id: 0, index: 0, checkFotoBarangPendukung: false, fotoBarangPendukungPlaceholder: 'Choose a file', fotoBarangPendukung: null, fotoBarangPendukungBase64: null, activeFotoPendukungBase64: null }
            ]
            this.indexFotoPendukung = 1

            let pTipePinjaman = this.$axios.get('jenis-pinjaman/').then(res => {
                if (Array.isArray(res.data) && res.data.length > 0) {
                    this.optTipePinjaman = res.data
                }
            }).catch(() => {
                this.optTipePinjaman = [
                    { id: 1, name: 'Gadai Elektronik' },
                    { id: 2, name: 'Gadai Kendaraan' }
                ]
            })

            let pJenisAtribut = this.$axios.get('barang-jenis-atribut/').then(res => {
                let list = Array.isArray(res.data) ? res.data : (res.data && res.data.data ? res.data.data : [])
                if (list.length > 0) {
                    this.optAllJenisBarang = list.map((item, idx) => ({
                        id: item.jenisBarangId || item.id || (idx + 1),
                        tipePinjamanId: item.jenisPinjaman ? item.jenisPinjaman.id : (item.tipePinjamanId || 1),
                        name: item.jenisBarangName || item.name || '',
                        merks: Array.isArray(item.merkBarang) ? item.merkBarang : []
                    }))
                }
            }).catch(() => {})

            let pWarna = this.$axios.get('gadai/warna').then(res => {
                if (Array.isArray(res.data) && res.data.length > 0) {
                    this.optWarna = res.data.map(item => ({ value: item.id || item.name, text: item.name }))
                }
            }).catch(() => {})

            Promise.all([pTipePinjaman, pJenisAtribut, pWarna]).finally(() => {
                this.initStatus = 1
                if (this.optTipePinjaman.length > 0 && !this.input.tipePinjamanId) {
                    this.input.tipePinjamanId = this.optTipePinjaman[0].id
                }
            })
        },

        parseOptions(options) {
            if (!options) return []
            if (Array.isArray(options)) return options
            if (typeof options === 'string' && options.trim() !== '') {
                return options.split(',').map(s => s.trim()).filter(Boolean)
            }
            return []
        },

        fetchDynamicAttributes(jenisBarangId) {
            if (!jenisBarangId) {
                this.dynamicAttributes = []
                this.dynamicValues = {}
                this.isLoadingAttributes = false
                return
            }

            this.isLoadingAttributes = true
            this.$axios.get(`barang-jenis-atribut/${jenisBarangId}`).then(res => {
                let data = res.data
                let list = []
                if (Array.isArray(data)) {
                    list = data
                } else if (data && Array.isArray(data.atribut)) {
                    list = data.atribut
                } else if (data && Array.isArray(data.attributes)) {
                    list = data.attributes
                } else if (data && Array.isArray(data.atributList)) {
                    list = data.atributList
                } else if (data && Array.isArray(data.data)) {
                    list = data.data
                }

                if (list && list.length > 0) {
                    this.dynamicAttributes = list.map((item, idx) => {
                        let label = item.label || item.name || `Atribut ${idx + 1}`
                        let nameKey = item.nameKey || (label ? label.toLowerCase().replace(/[^a-z0-9]+/g, '_') : `attr_${idx}`)
                        let dataType = item.dataType || item.type || 'Freetext'
                        let lengthLimit = item.lengthLimit !== undefined && item.lengthLimit !== null ? item.lengthLimit : (item.length || null)
                        let mandatory = item.mandatory !== undefined ? Boolean(item.mandatory) : Boolean(item.isMandatory)
                        let options = item.options || []

                        return {
                            id: item.id || item.atributId || idx,
                            label: label,
                            nameKey: nameKey,
                            dataType: dataType,
                            lengthLimit: lengthLimit,
                            mandatory: mandatory,
                            options: options
                        }
                    })

                    // Initialize dynamic form values reactively
                    this.dynamicValues = {}
                    for (let attr of this.dynamicAttributes) {
                        if (attr.dataType === 'Multi Select') {
                            this.$set(this.dynamicValues, attr.nameKey, [])
                        } else {
                            this.$set(this.dynamicValues, attr.nameKey, null)
                        }
                    }
                } else {
                    this.dynamicAttributes = []
                    this.dynamicValues = {}
                }
            }).catch(err => {
                console.warn('Gagal memuat dynamic attributes:', err)
                this.dynamicAttributes = []
                this.dynamicValues = {}
            }).finally(() => {
                this.isLoadingAttributes = false
            })
        },

        // Member Handlers
        openSearchAnggotaModal() {
            this.$bvModal.show("modal-pilih-anggota")
        },
        addAnggota() {
            this.$bvModal.show("modal-input-anggota")
        },
        inputNewAnggota(dataAnggota) {
            this.setAnggotaData(dataAnggota)
            this.$bvModal.hide("modal-input-anggota")
        },
        editNewAnggota(dataAnggota) {
            this.setAnggotaData(dataAnggota)
            this.$bvModal.hide("modal-edit-anggota")
        },
        selectAnggota(dataAnggota) {
            this.setAnggotaData(dataAnggota)
            this.$bvModal.hide("modal-pilih-anggota")
        },
        setAnggotaData(dataAnggota) {
            if (!dataAnggota) return
            this.anggota.id = dataAnggota.id || dataAnggota.idAnggota || null
            this.anggota.nama = dataAnggota.nama || '-'
            this.anggota.no = dataAnggota.noAnggota || dataAnggota.no || '-'
            this.anggota.noIdentitas = dataAnggota.noIdentitas || '-'

            let jenisIdName = '-'
            if (dataAnggota.jenisIdentitas) {
                if (typeof dataAnggota.jenisIdentitas === 'object' && dataAnggota.jenisIdentitas !== null) {
                    jenisIdName = dataAnggota.jenisIdentitas.name || dataAnggota.jenisIdentitas.label || '-'
                } else {
                    jenisIdName = dataAnggota.jenisIdentitas
                }
            }
            this.anggota.jenisIdentitas = jenisIdName

            this.anggota.noHp = dataAnggota.noHp || '-'
            this.anggota.noRumah = dataAnggota.noRumah || '-'
            this.anggota.alamat = dataAnggota.alamat || '-'
            this.anggota.isComplete = Boolean(dataAnggota.isComplete)
        },

        // Photo / Webcam Handlers
        openModalCam(index) {
            this.activeFotoPendukungIndex = index
            this.$bvModal.show("webcam-input-pengajuan")
        },
        openModalPreview(index) {
            this.activeFotoPreviewIndex = index
            let idx = this.input.fotoPendukung.findIndex(item => item.index === this.activeFotoPreviewIndex)
            if (idx !== -1) {
                this.activeFotoPreview = this.input.fotoPendukung[idx].fotoBarangPendukungBase64
                this.$bvModal.show("modal-preview-gadai")
            }
        },
        async setResult(result) {
            let newResult = await this.$helper.resizeImage(result)
            let idx = this.input.fotoPendukung.findIndex(item => item.index === this.activeFotoPendukungIndex)
            if (idx !== -1) {
                this.input.fotoPendukung[idx].fotoBarangPendukungBase64 = newResult
                this.input.fotoPendukung[idx].activeFotoPendukungBase64 = newResult
                this.input.fotoPendukung[idx].fotoBarangPendukungPlaceholder = "Foto dari Kamera"
                this.input.fotoPendukung[idx].checkFotoBarangPendukung = true
            }
        },
        addFotoPendukung() {
            if (this.input.fotoPendukung.length < 6) {
                this.input.fotoPendukung.push({ 
                    id: 0, 
                    index: this.indexFotoPendukung,
                    checkFotoBarangPendukung: false,
                    fotoBarangPendukungPlaceholder: 'Choose a file',
                    fotoBarangPendukung: null,
                    fotoBarangPendukungBase64: null,
                    activeFotoPendukungBase64: null
                })
                this.indexFotoPendukung++
            } else {
                this.fotoPendukungError = true
            }
        },
        removeFotoPendukung(index) {
            this.input.fotoPendukung = this.input.fotoPendukung.filter(item => item.index !== index)
            this.fotoPendukungError = false
        },

        // Promo
        checkPromo() {
            if (!this.input.jenisBarang || !this.input.merkBarang || !this.input.tipeBarang) {
                this.$helper.toastErr(this, "Mohon lengkapi jenis, merk, dan tipe barang terlebih dahulu")
                return
            }

            const jId = this.input.jenisBarang.id || this.input.jenisBarang
            const mId = this.input.merkBarang.id || this.input.merkBarang
            const tId = this.input.tipeBarang.id || this.input.tipeBarang
            const cabangId = this.$helper.getCabangId ? this.$helper.getCabangId() : ''
            const pId = this.input.tipePinjamanId || 1

            let path = `gadai-crud/promo?jenisPinjamanId=${pId}&jenisBarangId=${jId}&merkId=${mId}&tipeId=${tId}&cabangId=${cabangId}`
            if (this.input.tahun) {
                let thnId = this.input.tahun.id || this.input.tahun
                path += `&tahunId=${thnId}`
            }

            this.input.promo = []
            this.isGettingPromo = true
            this.$axios.get(path).then(response => {
                this.optPromo = Array.isArray(response.data) ? response.data : []
                this.isPromoRetrieved = true
            }).catch(() => {
                this.optPromo = []
                this.isPromoRetrieved = true
            }).finally(() => {
                this.isGettingPromo = false
            })
        },

        // Submit & Calculations
        calculateMaksimumPinjaman() {
            if (!this.anggota.id) {
                this.$helper.toastErr(this, 'Mohon pilih data anggota terlebih dahulu!')
                return
            }
            if (!this.input.jenisBarang || !this.input.merkBarang) {
                this.$helper.toastErr(this, 'Mohon lengkapi jenis dan merk barang!')
                return
            }
            if (this.isKendaraan && !this.input.tahun) {
                this.$helper.toastErr(this, 'Mohon pilih tahun barang!')
                return
            }

            // Check dynamic mandatory fields
            for (let attr of this.dynamicAttributes) {
                if (attr.mandatory || attr.isMandatory) {
                    let val = this.dynamicValues[attr.nameKey]
                    if (val === undefined || val === null || val === '' || (Array.isArray(val) && val.length === 0)) {
                        this.$helper.toastErr(this, `Atribut ${attr.label} wajib diisi!`)
                        return
                    }
                }
            }

            // Check if there is at least one picture attached
            if (this.input.fotoPendukung.length === 1 && this.$helper.isNullOrEmpty(this.input.fotoPendukung[0].activeFotoPendukungBase64)) {
                this.$helper.toastErr(this, "Mohon upload minimal 1 gambar!")
                return
            }

            let payload = this.preparePayload()

            this.isSubmitting = true
            this.$axios.post('gadai-crud/pengajuan', payload).then(response => {
                if (response.data.noFaktur === 'REFRESH_KONDISI') {
                    this.$helper.toastErr(this, 'Harga barang baru saja diperbarui HO. Silahkan isi ulang Kondisi / Grade Barang!')
                    this.input.kondisi = null
                    this.$axios.get(`barang-tipe/kondisi/${this.input.tipeBarang.id}`).then(res => {
                        this.optKondisi = res.data.map(item => ({ value: item.id, text: item.name }))
                    }).catch(() => {})
                } else {
                    this.rincian = response.data
                    if (response.data.noFakturSuspectGanda != null) {
                        this.rincian.showAlertNoFakturGanda = true
                        this.rincian.alertNoFakturGanda = response.data.noFakturSuspectGanda
                        this.rincian.alertGadai = 'pengajuan'
                    }
                    this.namaLengkapBarang = `${this.currentJenisBarangName} - ${this.currentMerkBarangName} - ${this.input.tipeBarang ? this.input.tipeBarang.name : ''}`
                    if (this.isKendaraan && this.input.tahun) {
                        this.namaLengkapBarang += ` - ${this.input.tahun.name || this.input.tahun}`
                    }
                    this.$bvModal.show('modal-rincian')
                }
            }).catch(error => {
                this.$helper.parseError(this, error)
            }).finally(() => {
                this.isSubmitting = false
            })
        },

        calculateConfirmation(nilaiPinjaman) {
            if (nilaiPinjaman % 50000 !== 0) {
                this.$helper.toastErr(this, "Pinjaman hanya boleh dalam kelipatan Rp 50.000")
                return
            }

            let payload = this.preparePayload(nilaiPinjaman)

            this.isSubmitting = true
            this.$axios.post('gadai-crud/pengajuan', payload).then(response => {
                if (response.data.noFaktur === 'REFRESH_KONDISI') {
                    this.$helper.toastErr(this, 'Harga barang baru saja diperbarui HO. Silahkan isi ulang Kondisi / Grade Barang!')
                    this.input.kondisi = null
                    this.$bvModal.hide('modal-rincian')
                } else {
                    this.rincian = response.data
                    this.$bvModal.hide('modal-rincian')
                    this.$bvModal.show('modal-konfirmasi')
                }
            }).catch(error => {
                this.$helper.parseError(this, error)
            }).finally(() => {
                this.isSubmitting = false
            })
        },

        submitGadai() {
            let payload = this.preparePayload(this.input.nilaiPinjaman, true)

            this.isSubmitting = true
            this.$axios.post('gadai-crud/pengajuan', payload, { timeout: 300000 }).then(response => {
                if (response.data.noFaktur === 'REFRESH_KONDISI') {
                    this.$helper.toastErr(this, 'Harga barang baru saja diperbarui HO. Silahkan isi ulang Kondisi / Grade Barang!')
                    this.input.kondisi = null
                    this.$bvModal.hide('modal-konfirmasi')
                    this.$bvModal.hide('modal-rincian')
                } else {
                    let data = response.data
                    this.rincian.noFaktur = data.noFaktur
                    this.$bvModal.hide('modal-konfirmasi')
                    this.$bvModal.show('modal-sukses')
                }
            }).catch(error => {
                this.$helper.parseError(this, error)
            }).finally(() => {
                this.isSubmitting = false
            })
        },

        getActiveCabangId() {
            let active = localStorage.getItem("activeCabangId")
            if (active && active !== "0" && active !== 0 && active !== "null") {
                return active
            }
            try {
                let allCabang = JSON.parse(localStorage.getItem("cabang") || "[]")
                if (Array.isArray(allCabang) && allCabang.length > 0) {
                    return allCabang[0].id
                }
            } catch (e) {}
            return active || 0
        },

        preparePayload(nilaiPinjaman = null, finalizePayment = false) {
            let payload = new FormData()
            payload.append('nasabahId', this.anggota.id)
            payload.append('jenisPinjamanId', this.input.tipePinjamanId || 1)
            
            if (this.input.jenisBarang) {
                payload.append('jenisBarangId', this.input.jenisBarang.id !== undefined ? this.input.jenisBarang.id : this.input.jenisBarang)
            }
            if (this.input.merkBarang) {
                payload.append('merkId', this.input.merkBarang.id !== undefined ? this.input.merkBarang.id : this.input.merkBarang)
            }
            if (this.input.tipeBarang) {
                payload.append('tipeId', this.input.tipeBarang.id !== undefined ? this.input.tipeBarang.id : this.input.tipeBarang)
            }
            if (this.input.kondisi) {
                payload.append('kondisiId', this.input.kondisi)
            }
            if (this.input.warnaBarang) {
                payload.append('warnaId', this.input.warnaBarang)
            }
            if (this.isKendaraan && this.input.tahun) {
                payload.append('tahunId', this.input.tahun.id !== undefined ? this.input.tahun.id : this.input.tahun)
            }

            let cabangId = this.getActiveCabangId()
            payload.append('cabangId', cabangId)
            payload.append('finalizePayment', finalizePayment)
            payload.append('keterangan', this.input.keterangan || '')

            // Dynamic attributes (Parallel Array: attrNameKey & attrValue)
            for (let attr of this.dynamicAttributes) {
                let val = this.dynamicValues[attr.nameKey]
                let valStr = ''
                if (val !== undefined && val !== null) {
                    if (Array.isArray(val)) {
                        valStr = val.join(',')
                    } else if (typeof val === 'boolean') {
                        valStr = val ? 'true' : 'false'
                    } else {
                        valStr = String(val).trim()
                    }
                }
                payload.append('attrNameKey', attr.nameKey)
                payload.append('attrValue', valStr)
            }

            // Kelengkapan
            if (this.input.kelengkapanBarang && this.input.kelengkapanBarang.length > 0) {
                this.input.kelengkapanBarang.forEach(item => {
                    payload.append('kelengkapan', typeof item === 'object' && item !== null ? item.name : item)
                })
            }

            // Spesifikasi Jenis
            if (this.input.spesifikasiBarangJenis && this.input.spesifikasiBarangJenis.length > 0) {
                this.input.spesifikasiBarangJenis.forEach(spek => {
                    payload.append('spesifikasiId', spek)
                })
            }

            // Spesifikasi Merk
            if (this.input.spesifikasiBarangMerk && this.input.spesifikasiBarangMerk.length > 0) {
                this.input.spesifikasiBarangMerk.forEach(spek => {
                    payload.append('spesifikasiId', spek)
                })
            }

            // Promo
            if (this.input.promo && this.input.promo.length > 0) {
                this.input.promo.forEach(pId => {
                    payload.append('promoIds', pId)
                })
            }

            if (nilaiPinjaman !== null) {
                this.input.nilaiPinjaman = nilaiPinjaman
                payload.append('jumlahPinjaman', nilaiPinjaman)
            }

            if (finalizePayment) {
                let jsonFoto = []
                this.input.fotoPendukung.forEach(entry => {
                    if (entry.activeFotoPendukungBase64) {
                        jsonFoto.push(entry.activeFotoPendukungBase64)
                    }
                })
                payload.append('foto', JSON.stringify(jsonFoto))
            }

            return payload
        },

        reset() {
            this.$bvModal.hide("modal-sukses")
            this.$bvModal.hide("modal-konfirmasi")
            this.$bvModal.hide("modal-rincian")

            this.anggota = {
                id: null,
                nama: "-",
                no: "-",
                jenisBarang: "-",
                jenisIdentitas: "-",
                noIdentitas: "-",
                noHp: "-",
                noRumah: "-",
                alamat: "-",
                isComplete: false,
                shouldUpdate: false
            }

            this.rincian = {
                hargaBarang: 0,
                maksimumPinjaman: 0,
                minimumPinjaman: 0,
                perhitunganPromo: null,
                perhitunganKondisi: {},
                perhitunganSpek: [],
                perhitunganBonusGadaiPertama: {},
                perhitunganStatusAnggota: {},
                biayaAdmin: 0,
                noFaktur: "",
                showAlertNoFakturGanda: "false",
                alertNoImei: "",
                alertNoFakturGanda: "",
                alertGadai: "pengajuan"
            }

            this.namaLengkapBarang = ""

            this.input.jenisBarang = null
            this.input.merkBarang = null
            this.input.tipeBarang = null
            this.input.tahun = null
            this.input.kondisi = null
            this.input.warnaBarang = null
            this.input.kelengkapanBarang = []
            this.input.spesifikasiBarangJenis = []
            this.input.spesifikasiBarangMerk = []
            this.input.keterangan = ""
            this.input.promo = []
            this.input.nilaiPinjaman = 0
            this.input.fotoPendukung = [
                { id: 0, index: 0, checkFotoBarangPendukung: false, fotoBarangPendukungPlaceholder: 'Choose a file', fotoBarangPendukung: null, fotoBarangPendukungBase64: null, activeFotoPendukungBase64: null }
            ]
            this.indexFotoPendukung = 1

            this.dynamicAttributes = []
            this.dynamicValues = {}
            this.optMerkBarang = []
            this.optTipeBarang = []
            this.optTahun = []
            this.optKondisi = []
            this.optKelengkapanBarang = []
            this.optSpekJenis = { penambahan: [], pengurangan: [] }
            this.optSpekMerk = { penambahan: [], pengurangan: [] }
            this.optPromo = []
            this.isPromoRetrieved = false

            window.scrollTo({ top: 0, behavior: 'smooth' })
        }
    },
    watch: {
        'input.tipePinjamanId': function(newVal) {
            this.input.jenisBarang = null
            this.input.merkBarang = null
            this.input.tipeBarang = null
            this.input.tahun = null
            this.input.kondisi = null
            this.dynamicAttributes = []
            this.dynamicValues = {}
            this.optMerkBarang = []
            this.optTipeBarang = []
            this.optTahun = []
            this.optKondisi = []
            this.optKelengkapanBarang = []
            this.input.kelengkapanBarang = []
            this.optSpekJenis = { penambahan: [], pengurangan: [] }
            this.input.spesifikasiBarangJenis = []
            this.optSpekMerk = { penambahan: [], pengurangan: [] }
            this.input.spesifikasiBarangMerk = []
            this.optPromo = []
            this.input.promo = []
            this.isPromoRetrieved = false
        },

        'input.jenisBarang': function(newVal) {
            this.optMerkBarang = []
            this.input.merkBarang = null
            this.optTipeBarang = []
            this.input.tipeBarang = null
            this.optTahun = []
            this.input.tahun = null
            this.optKondisi = []
            this.input.kondisi = null
            this.optKelengkapanBarang = []
            this.input.kelengkapanBarang = []
            this.optSpekJenis = { penambahan: [], pengurangan: [] }
            this.input.spesifikasiBarangJenis = []
            this.optSpekMerk = { penambahan: [], pengurangan: [] }
            this.input.spesifikasiBarangMerk = []
            this.optPromo = []
            this.input.promo = []
            this.isPromoRetrieved = false
            this.dynamicAttributes = []
            this.dynamicValues = {}

            if (!newVal) return
            const jId = newVal.id !== undefined ? newVal.id : newVal
            if (!jId) return

            // 1. Fetch Dynamic Attributes for this Jenis Barang
            this.fetchDynamicAttributes(jId)

            // 2. Fetch Merks
            this.$axios.get(`barang-merk/jenis/${jId}`).then(res => {
                if (Array.isArray(res.data)) {
                    this.optMerkBarang = res.data
                }
            }).catch(() => {
                const found = this.optAllJenisBarang.find(j => j.id === jId)
                if (found && found.merks && found.merks.length > 0) {
                    this.optMerkBarang = found.merks
                }
            })

            // 3. Fetch Kelengkapan Barang
            this.$axios.get(`barang-jenis/kelengkapan?jenisId=${jId}`).then(res => {
                if (Array.isArray(res.data)) {
                    this.optKelengkapanBarang = res.data
                }
            }).catch(() => {})

            // 4. Fetch Spek Jenis
            this.$axios.get(`barang-jenis/spesifikasi?jenisId=${jId}`).then(res => {
                if (res.data) {
                    this.optSpekJenis = res.data
                }
            }).catch(() => {})
        },

        'input.merkBarang': function(newVal) {
            this.optTipeBarang = []
            this.input.tipeBarang = null
            this.optTahun = []
            this.input.tahun = null
            this.optKondisi = []
            this.input.kondisi = null
            this.optSpekMerk = { penambahan: [], pengurangan: [] }
            this.input.spesifikasiBarangMerk = []
            this.optPromo = []
            this.input.promo = []
            this.isPromoRetrieved = false

            if (!newVal) return
            const mId = newVal.id !== undefined ? newVal.id : newVal
            if (!mId) return

            // 1. Fetch Tipe
            this.$axios.get(`barang-tipe/merk/${mId}`).then(res => {
                if (Array.isArray(res.data)) {
                    this.optTipeBarang = res.data
                }
            }).catch(err => {
                console.warn('Gagal memuat tipe barang:', err)
            })

            // 2. Fetch Spek Merk
            this.$axios.get(`barang-merk/spesifikasi?merkId=${mId}`).then(res => {
                if (res.data) {
                    this.optSpekMerk = res.data
                }
            }).catch(() => {})
        },

        'input.tipeBarang': function(newVal) {
            this.optTahun = []
            this.input.tahun = null
            this.optKondisi = []
            this.input.kondisi = null
            this.optPromo = []
            this.input.promo = []
            this.isPromoRetrieved = false

            if (!newVal) return
            const tId = newVal.id !== undefined ? newVal.id : newVal
            if (!tId) return

            // 1. Fetch Tahun
            this.$axios.get(`barang-tipe/tahun/${tId}`).then(res => {
                if (Array.isArray(res.data)) {
                    this.optTahun = res.data
                }
            }).catch(() => {})

            // 2. Fetch Kondisi
            this.$axios.get(`barang-tipe/kondisi/${tId}`).then(res => {
                if (Array.isArray(res.data)) {
                    this.optKondisi = res.data.map(item => ({ value: item.id, text: item.name }))
                }
            }).catch(() => {})
        },

        'input.tahun': function() {
            this.optPromo = []
            this.input.promo = []
            this.isPromoRetrieved = false
        }
    },
    created() {
        this.init()
    }
}
</script>

<style lang="scss" scoped>
.master-form-page {
    padding-bottom: 40px;
}

.page-header-title {
    font-size: 20px;
    font-weight: 700;
    color: #0b3b36;
    letter-spacing: -0.2px;
    margin-bottom: 2px;
}

.page-header-subtitle {
    font-size: 13px;
    color: #64748b;
}

.step-badge {
    background-color: #f0fdf4;
    color: #166534;
    border: 1px solid #bbf7d0;
    border-radius: 20px;
    padding: 6px 14px;
    font-size: 12.5px;
    font-weight: 600;
    display: inline-flex;
    align-items: center;

    .step-dot {
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background-color: #eab308;
        margin-right: 6px;
    }
}

/* Section Card */
.section-card {
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid #edf2f0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
    margin-bottom: 24px;
    overflow: hidden;
}

.section-card-header {
    background-color: #e8f3ef;
    padding: 14px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #dbeae4;

    &--promo {
        background-color: #fff7ed !important;
        border-bottom-color: #ffedd5 !important;

        .section-card-title {
            color: #9a3412 !important;
        }
    }
}

.section-card-title {
    font-size: 12.5px;
    font-weight: 700;
    letter-spacing: 0.8px;
    color: #0b3b36;
    text-transform: uppercase;
}

.section-card-body {
    padding: 20px 24px;
}

/* Buttons */
.btn-pill-primary {
    background-color: #0b3b36;
    color: #ffffff;
    border: 1px solid #0b3b36;
    border-radius: 8px;
    padding: 7px 18px;
    font-size: 13px;
    font-weight: 600;
    transition: all 0.2s ease;
    cursor: pointer;

    &:hover:not(:disabled) {
        background-color: #082d29;
        border-color: #082d29;
        color: #ffffff;
    }
}

.btn-pill-outline {
    background-color: #ffffff;
    color: #0b3b36;
    border: 1px solid #c2dbd1;
    border-radius: 8px;
    padding: 7px 18px;
    font-size: 13px;
    font-weight: 600;
    margin-left: 8px;
    transition: all 0.2s ease;

    &:hover {
        background-color: #f2f8f5;
        border-color: #0b3b36;
        color: #0b3b36;
    }
}

.btn-outline-neutral {
    background-color: #ffffff;
    border: 1px solid #d8e2dc;
    color: #334155;
    border-radius: 8px;
    padding: 7px 16px;
    font-size: 13px;
    font-weight: 500;

    &:hover {
        background-color: #f8fafc;
        border-color: #94a3b8;
        color: #0f172a;
    }
}

/* Form Controls */
.field-label {
    font-size: 12.5px;
    font-weight: 600;
    color: #334155;
    margin-bottom: 6px;
    display: block;
}

.form-control-custom {
    border-radius: 8px !important;
    border: 1px solid #d8e2dc !important;
    font-size: 13px !important;
    padding: 8px 12px !important;
    height: auto !important;
    color: #1e293b !important;
    transition: all 0.2s ease;

    &:focus {
        border-color: #0b3b36 !important;
        box-shadow: 0 0 0 3px rgba(11, 59, 54, 0.1) !important;
    }

    &:disabled {
        background-color: #f8fafc !important;
        color: #94a3b8 !important;
    }
}

.field-help-text {
    font-size: 11px;
    color: #94a3b8;
    margin-top: 3px;
    display: block;
}

/* Member Info Panel */
.member-info-panel {
    background-color: #fafdfb;
    border: 1px solid #e2ece7;
    border-radius: 10px;
    padding: 16px 20px;
}

.member-item-row {
    display: flex;
    margin-bottom: 8px;
    font-size: 13px;

    &:last-child {
        margin-bottom: 0;
    }

    .member-item-label {
        width: 130px;
        color: #64748b;
        flex-shrink: 0;
    }

    .member-item-value {
        color: #0f172a;
    }
}

/* Dynamic Attributes Panel */
.dynamic-attributes-panel {
    background-color: #f7faf9;
    border: 1px solid #ddecde;
    border-radius: 10px;
    padding: 16px 20px;
}

.panel-subtitle {
    font-size: 13px;
    color: #0b3b36;
}

.breadcrumb-subtle {
    font-size: 11.5px;
    color: #64748b;
    font-weight: 500;
}

.border-bottom-subtle {
    border-bottom: 1px solid #e0ebe6;
}

/* Pills Checkbox */
.custom-checkbox-pill-group {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

::v-deep .custom-check-pill {
    margin-right: 0;

    .custom-control-label {
        background-color: #f1f5f9;
        color: #475569;
        border: 1px solid #cbd5e1;
        border-radius: 20px;
        padding: 5px 14px;
        font-size: 12.5px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.15s ease;
        user-select: none;

        &::before, &::after {
            display: none !important;
        }
    }

    .custom-control-input:checked ~ .custom-control-label {
        background-color: #e8f3ef !important;
        color: #0b3b36 !important;
        border-color: #0b3b36 !important;
        font-weight: 600;
        box-shadow: 0 1px 3px rgba(11, 59, 54, 0.12);
    }
}

/* Spek Blocks */
.spek-block {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 12px 16px;
}

.spek-subhead {
    font-size: 11.5px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #64748b;
    display: block;
    margin-bottom: 8px;
}

.checkbox-list {
    ::v-deep .custom-control-label {
        font-size: 12.5px;
        color: #334155;
        cursor: pointer;
    }
}

/* Photo Slots & Foto Pendukung Styling */
.photo-slots-container {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
}

::v-deep .form-dynamic-wrapper {
    background-color: #fafdfc;
    border: 1px solid #ddecde;
    border-radius: 10px;
    padding: 16px 20px 12px;
    position: relative;
    width: 100%;
    max-width: 480px;
}

::v-deep .form-dynamic-wrapper .col-md-6,
::v-deep .form-dynamic-wrapper .col-lg-6 {
    max-width: 100% !important;
    flex: 0 0 100% !important;
}

::v-deep .foto-input-wrapper {
    display: flex !important;
    max-width: 100% !important;
    width: 100% !important;
    align-items: center;
    gap: 14px;
}

::v-deep .foto-preview-wrapper {
    width: 220px !important;
    min-width: 180px !important;
    height: 130px !important;
    border: 1.5px dashed #0b3b36 !important;
    border-radius: 10px !important;
    background-color: #f7faf9 !important;
    margin-right: 0 !important;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    position: relative;
}

::v-deep .foto-preview-wrapper .text-blue {
    color: #64748b !important;
    font-size: 13px !important;
    font-weight: 600 !important;
    margin-bottom: 0 !important;
}

::v-deep .foto-action-wrapper {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

::v-deep .foto-action-wrapper .action-browse-wrapper,
::v-deep .foto-action-wrapper .action-camera-wrapper,
::v-deep .foto-action-wrapper .action-reset-wrapper {
    margin-bottom: 0 !important;
    margin-top: 0 !important;
}

::v-deep .foto-action-wrapper button {
    min-width: 120px !important;
    border-radius: 8px !important;
    font-size: 13px !important;
    font-weight: 500 !important;
    padding: 7px 14px !important;
}

::v-deep .form-dynamic-deleteWrapper {
    position: absolute;
    top: 12px;
    right: 12px;

    .btn-dynamicDeleteBtn {
        border-radius: 6px;
        width: 28px;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        background-color: #fee2e2;
        color: #dc2626;
        border: 1px solid #fca5a5;
        transition: all 0.2s ease;

        &:hover {
            background-color: #dc2626;
            color: #ffffff;
        }

        &:disabled {
            opacity: 0.4;
            cursor: not-allowed;
            background-color: #f1f5f9;
            color: #94a3b8;
            border-color: #e2e8f0;
        }
    }
}

.font-weight-500 {
    font-weight: 500;
}

/* Multiselect Brand Styling */
::v-deep .multiselect {
    min-height: 38px;

    .multiselect__tags {
        min-height: 38px;
        border-radius: 8px;
        border: 1px solid #d8e2dc;
        padding: 5px 40px 0 8px;
        background-color: #ffffff;
        transition: all 0.2s ease;
    }

    &.multiselect--active .multiselect__tags {
        border-color: #0b3b36;
        box-shadow: 0 0 0 2px rgba(11, 59, 54, 0.12);
    }

    .multiselect__tag {
        background-color: #0b3b36 !important;
        color: #ffffff !important;
        border-radius: 6px !important;
        padding: 4px 26px 4px 10px !important;
        font-size: 12px !important;
        font-weight: 500 !important;
        margin-right: 6px !important;
        margin-bottom: 4px !important;
        border: 1px solid #082d29 !important;
    }

    .multiselect__tag-icon {
        border-radius: 0 5px 5px 0;

        &:after {
            color: #ffffff !important;
            font-size: 14px;
            font-weight: 700;
        }

        &:hover,
        &:focus {
            background-color: #082d29 !important;

            &:after {
                color: #ffffff !important;
            }
        }
    }

    .multiselect__option--highlight {
        background-color: #0b3b36 !important;
        color: #ffffff !important;

        &:after {
            background-color: transparent !important;
            color: #ffffff !important;
        }
    }

    .multiselect__option--selected {
        background-color: #e8f3ef !important;
        color: #0b3b36 !important;
        font-weight: 600 !important;

        &:after {
            background-color: transparent !important;
            color: #0b3b36 !important;
        }
    }

    .multiselect__option--selected.multiselect__option--highlight {
        background-color: #cde6dc !important;
        color: #0b3b36 !important;
        font-weight: 600 !important;

        &:after {
            background-color: transparent !important;
            color: #0b3b36 !important;
        }
    }
}
</style>
